<template>
  <div class="CharacterPieces">
    <draggable
      class="character"
      v-for="character in characters"
      v-if="get(character.key)"
      :key="character.key"
      :x="character.x"
      :y="character.y"
      :z="character.y"
      :w="60 * get(character.key).size"
      :h="60 * get(character.key).size"
      :resizable="false"
      :ratio="Number(tableScale)"
      @change="(x, y) => onChange(character.key, x, y)"
    >
      <!-- <transition name="fade">
        <p class="objectBaloon" v-if="false" :class="{ success: true }" :key="1"></p>
      </transition> -->
      <figure class="image" @dblclick="showDetail(character.key)">
        <img
          v-if="src(get(character.key).imageKey)"
          :src="src(get(character.key).imageKey)"
          draggable="false"
        >
      </figure>
      <p class="name m-ellipsis" v-text="get(character.key).name"></p>
      <div class="tips">
        <pre v-if="get(character.key).note" v-text="get(character.key).note"></pre>
      </div>
    </draggable>
  </div>
</template>

<script>
import draggable from '../common/draggable'

export default {
  components: { draggable },
  computed: {
    characters() {
      return this.$store.getters['characterList/$items']
    },
    tableScale() {
      return this.$store.getters['local/tableScale']
    },
    src() {
      return this.$store.getters['images/getSrc']
    },
    get() {
      return this.$store.getters['characters/$get']
    },
    role() {
      return this.$store.getters['local/role']
    }
  },
  methods: {
    onChange(key, x, y) {
      this.$store.dispatch('characterList/setPos', { key, data: { x, y } })
    },
    showDetail(key) {
      const character = this.get(key)
      if ((character && !character.hidden) || this.role > 5) {
        this.$store.commit('characters/$checkout', key)
      }
    }
  }
}
</script>

<style scoped>
.CharacterPieces {
  width: 0;
  height: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  /* z-index: 1; */
}
.character {
  /* width: 60px;
  height: 60px; */
  position: absolute;
  display: flex;
  /* align-items: center; */
  /* justify-content: center; */
}
.character .tips {
  padding-top: 7px;
  display: none;
  position: absolute;
  top: 100%;
  left: 50%;
  width: 240px;
  transform: translateX(-50%);
}
.character .tips pre {
  padding: 4px 8px;
  border-radius: 2px;
  /* max-height: 240px; */
  background: rgba(0, 0, 0, 0.8);
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);
  color: #ccc;
  font-size: 11px;
  white-space: pre-wrap;
  z-index: 1;
  line-height: 1.6;
  letter-spacing: 0.05em;
}
.character:hover .tips {
  display: block;
}
.character.active .tips {
  display: none;
}
.character .image {
  /* border-radius: 50%; */
  /* overflow: hidden; */
  /* object-fit: contain; */
  /* background: #fff; */
  width: 100%;
  height: 100%;
  cursor: pointer;
  /* filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.8)); */
}

.character .image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.character .name {
  margin-bottom: 8px;
  padding: 4px;
  position: absolute;
  bottom: 100%;
  left: 50%;
  max-width: 120px;
  width: auto;
  transform: translateX(-50%);
  text-align: center;
  font-size: 10px;
  color: #fff;
  background: rgba(0, 0, 0, 0.2);
}
</style>
